var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page horizontal ltr"},[_c('LandingHeader'),_c('main',[_c('router-view')],1),_c('LandingFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }